// extracted by mini-css-extract-plugin
export var basic = "video-module--basic--90f74";
export var close = "video-module--close--30002";
export var content = "video-module--content--a3395";
export var copy = "video-module--copy--7c3e6";
export var cta = "video-module--cta--2b5b9";
export var description = "video-module--description--7cf59";
export var doctor = "video-module--doctor--b8b68";
export var doctorCta = "video-module--doctor-cta--1662e";
export var doctorImage = "video-module--doctor-image--39d9f";
export var eyebrow = "video-module--eyebrow--8ff8d";
export var iconWrap = "video-module--icon-wrap--738ce";
export var images = "video-module--images--7c8b8";
export var inner = "video-module--inner--f02f7";
export var isOpen = "video-module--is-open--5a2bf";
export var media = "video-module--media--abe61";
export var modal = "video-module--modal--087cb";
export var modalDescription = "video-module--modal-description--f7a30";
export var play = "video-module--play--db997";
export var poster = "video-module--poster--54856";
export var title = "video-module--title--d5ca6";
export var transcript = "video-module--transcript--0f278";
export var transcriptButton = "video-module--transcript-button--996fe";
export var transcriptButtonWrap = "video-module--transcript-button-wrap--a0a10";